import { z } from 'zod/v4'

import {
  GenerateObjectCommandSchema,
  GenerateTextCommandSchema,
  GenerateResponseCommandSchema,
  TranscribeAudioCommandSchema,
} from './schemas'

// AI service schema (used in workflow file types and on the client)
export const AIServiceSchema = z.union([
  GenerateObjectCommandSchema,
  GenerateTextCommandSchema,
  GenerateResponseCommandSchema,
  TranscribeAudioCommandSchema,
])
